import { customerAddressEditFormSchema, } from './update-form.js';
import { updateCustomerAddressInputSchema } from './update-input.js';
export function toUpdateCustomerAddressInput(values, customerName) {
    const parsed = customerAddressEditFormSchema.parse(values);
    const input = {};
    if (customerName !== undefined) {
        input.name = customerName;
    }
    if (parsed.addressName !== undefined) {
        input.addressName = parsed.addressName;
    }
    if (parsed.typeId !== undefined && parsed.typeId.trim() !== '') {
        input.typeId = Number(parsed.typeId);
    }
    if (parsed.address !== undefined) {
        input.address = parsed.address;
    }
    if (parsed.city !== undefined) {
        input.city = parsed.city ?? null;
    }
    if (parsed.stateId !== undefined) {
        input.stateId = parsed.stateId ?? null;
    }
    if (parsed.countryId !== undefined) {
        input.countryId = parsed.countryId ?? null;
    }
    if (parsed.zip !== undefined) {
        input.zip = parsed.zip ?? null;
    }
    // The resolver already force-clears defaultFlag server-side for non-Shipping types (see
    // update-customer-address.ts) — no need to pre-empt that here.
    if (parsed.defaultFlag !== undefined) {
        input.defaultFlag = parsed.defaultFlag;
    }
    return updateCustomerAddressInputSchema.parse(input);
}
//# sourceMappingURL=update-mapper.js.map